import React from 'react';
import { Truck, Check } from 'lucide-react';

const FreeShippingBar = ({ subtotal, threshold = 250 }) => {
  const progress = Math.min(100, (subtotal / threshold) * 100);
  const amountRemaining = Math.max(0, threshold - subtotal);
  const qualifies = subtotal >= threshold;

  return (
    <div className="glass-card p-4 mb-4" data-testid="free-shipping-bar">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <Truck className={`w-5 h-5 ${qualifies ? 'text-green-400' : 'text-[#00F0FF]'}`} />
          <span className="text-sm font-medium text-white">
            {qualifies ? 'Free Shipping Unlocked!' : 'Free Shipping Progress'}
          </span>
        </div>
        {qualifies ? (
          <div className="flex items-center space-x-1 text-green-400">
            <Check className="w-4 h-4" />
            <span className="text-sm font-medium">FREE</span>
          </div>
        ) : (
          <span className="text-sm text-[#A1A7B5]">
            ${amountRemaining.toFixed(2)} away
          </span>
        )}
      </div>
      
      <div className="relative h-2 bg-[#1E2532] rounded-full overflow-hidden">
        <div 
          className={`absolute left-0 top-0 h-full rounded-full transition-all duration-500 ${
            qualifies ? 'bg-green-400' : 'bg-gradient-to-r from-[#00F0FF] to-[#00B8D9]'
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <div className="flex justify-between mt-2 text-xs text-[#A1A7B5]">
        <span>$0</span>
        <span>${threshold} (Free Shipping)</span>
      </div>
      
      {!qualifies && (
        <p className="text-xs text-[#A1A7B5] mt-2">
          Add <span className="text-[#00F0FF] font-medium">${amountRemaining.toFixed(2)}</span> more to qualify for free standard shipping!
        </p>
      )}
    </div>
  );
};

export default FreeShippingBar;
